var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('img',_vm._g(_vm._b({staticClass:"c-image",class:{ loaded: _vm.loaded },attrs:{"src":_vm.imgSrc},on:{"load":function($event){_vm.loaded = true},"error":_vm.onSrcError}},'img',_vm.imgProps,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }